module.exports = "http://cdn.realive.com.ua/src/views/player/documets/army/images/Armylogo.png";